export default {
  '成绩查询列表':'成绩查询列表',
  '计划':'计划',
  '请选择计划':'请选择计划',
  '查看成绩单':'查看成绩单',
  '生成成绩单':'生成成绩单',
  '学生':'学生',
}